var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 3.5c-.602.25-1.254.45-1.906.5a3.233 3.233 0 001.455-1.8c-.652.4-1.355.65-2.107.8-.602-.6-1.455-1-2.408-1-1.855 0-3.31 1.45-3.31 3.25 0 .25.05.5.1.75a9.259 9.259 0 01-6.77-3.35C.802 3.15.601 3.7.601 4.3c0 1.15.602 2.1 1.454 2.7a3.07 3.07 0 01-1.504-.4v.05c0 .45.05.8.2 1.2.402 1.05 1.304 1.8 2.458 2-.25.05-.552.1-.853.1-.2 0-.451 0-.602-.05.452 1.3 1.656 2.2 3.11 2.3-1.153.85-2.558 1.4-4.062 1.4-.251 0-.552 0-.803-.05 1.455.9 3.21 1.45 5.066 1.45 5.166 0 8.326-3.6 9.179-7.25.15-.65.2-1.3.2-1.95v-.45C14.997 4.7 15.55 4.15 16 3.5","fillRule":"evenodd"}));
}

Twitter.defaultProps = {"width":"16","height":"16"};

module.exports = Twitter;

Twitter.default = Twitter;
